import React from "react";
import assets from "../../util/assets";
import './no-request-received.css';
import {Col, Row,} from "reactstrap";
import ShareButtonComponent from "../ShareButtonComponent";

const NoRequestReceived = (props) => {
    return (
        <div style={{margin: "8% auto"}}>
            <img className="center-img"
                 style={{maxWidth: 240}}
                 src={assets.no_request}
            />
            <p className="no-request-text-message">
                {props.message}
            </p>
            {
                !props.hideShare &&
                <Row className="mt-5 mb-5 mx-2">
                    <Col md="12" sm="12"
                         className="text-center">
                        <ShareButtonComponent
                            shareList={props.shareList}/>
                    </Col>
                </Row>
            }

        </div>
    )
}

export default NoRequestReceived;